import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { Mjesto } from '@app/shared/models/mjesto';
import { UIComponents } from '@ntap/core';
import { first, map, Observable, tap } from 'rxjs';
import { OdabirPovezanogMjestaProviderDirective } from './odabir-povezanog-mjesta-provider.directive';

@Component({
  selector: 'app-odabir-mjesta',
  templateUrl: './odabir-mjesta.component.html',
  styleUrl: './odabir-mjesta.component.scss'
})
export class OdabirMjestaComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<Mjesto[]>();

  @ViewChild(OdabirPovezanogMjestaProviderDirective)
  appOdabirPovezanogMjestaProvider: OdabirPovezanogMjestaProviderDirective;

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Mjesto[] | null>;

  ngOnInit(): void {
    this.currentViewName = 'mjesto';
    this.currentViewState = {};
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.appOdabirPovezanogMjestaProvider
      .selectedItems$ as Observable<Mjesto[]>;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as Mjesto[]);
          }
        })
      )
      .subscribe();
  }
}
